(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[79067],{

/***/ 325523:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phongvu/desktop/buildpc",
      function () {
        return __webpack_require__(210627);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 210627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ desktop_buildpc; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Breadcrumbs/Breadcrumbs.es.js
var Breadcrumbs_es = __webpack_require__(955006);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/PrintBuildPc/PrintBuildPc.es.js
var PrintBuildPc_es = __webpack_require__(327601);
// EXTERNAL MODULE: ./components/HeadSection.tsx
var HeadSection = __webpack_require__(665207);
// EXTERNAL MODULE: ./components/Loading.tsx
var Loading = __webpack_require__(235904);
// EXTERNAL MODULE: ./containers/BuildPc/index.tsx
var BuildPc = __webpack_require__(860864);
// EXTERNAL MODULE: ./contexts/BuildPCContextV2.tsx
var BuildPCContextV2 = __webpack_require__(39486);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./modules/buildpc/desktop/BuildPC.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  @media print {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











const PbBuildPC = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57645), __webpack_require__.e(84868), __webpack_require__.e(18089), __webpack_require__.e(73676), __webpack_require__.e(25653), __webpack_require__.e(5441), __webpack_require__.e(51460), __webpack_require__.e(40059), __webpack_require__.e(70507), __webpack_require__.e(15930), __webpack_require__.e(40212), __webpack_require__.e(34785), __webpack_require__.e(48764), __webpack_require__.e(80771), __webpack_require__.e(6015), __webpack_require__.e(38361), __webpack_require__.e(40149), __webpack_require__.e(1528), __webpack_require__.e(27512), __webpack_require__.e(90823), __webpack_require__.e(24930), __webpack_require__.e(71925), __webpack_require__.e(40364), __webpack_require__.e(86827), __webpack_require__.e(23474), __webpack_require__.e(52237), __webpack_require__.e(92185), __webpack_require__.e(31871), __webpack_require__.e(17122), __webpack_require__.e(65725), __webpack_require__.e(60051), __webpack_require__.e(23862), __webpack_require__.e(44829), __webpack_require__.e(40440), __webpack_require__.e(29830), __webpack_require__.e(66673), __webpack_require__.e(6748), __webpack_require__.e(4499), __webpack_require__.e(49986), __webpack_require__.e(9508), __webpack_require__.e(10102), __webpack_require__.e(2835), __webpack_require__.e(21111), __webpack_require__.e(42129), __webpack_require__.e(25919), __webpack_require__.e(58705), __webpack_require__.e(75827), __webpack_require__.e(87310), __webpack_require__.e(58263), __webpack_require__.e(60544), __webpack_require__.e(95154), __webpack_require__.e(20510), __webpack_require__.e(2530), __webpack_require__.e(30162), __webpack_require__.e(29745), __webpack_require__.e(97103), __webpack_require__.e(16611), __webpack_require__.e(80025), __webpack_require__.e(46096), __webpack_require__.e(82904), __webpack_require__.e(51533), __webpack_require__.e(85675), __webpack_require__.e(73464), __webpack_require__.e(23686), __webpack_require__.e(82175), __webpack_require__.e(3243), __webpack_require__.e(12448), __webpack_require__.e(58640), __webpack_require__.e(71798), __webpack_require__.e(96179), __webpack_require__.e(10837), __webpack_require__.e(28105), __webpack_require__.e(47891), __webpack_require__.e(75958), __webpack_require__.e(57502), __webpack_require__.e(70293), __webpack_require__.e(10959), __webpack_require__.e(54726), __webpack_require__.e(81379), __webpack_require__.e(31518), __webpack_require__.e(66387), __webpack_require__.e(56996), __webpack_require__.e(13289), __webpack_require__.e(84650), __webpack_require__.e(43437), __webpack_require__.e(21514), __webpack_require__.e(89041), __webpack_require__.e(89442), __webpack_require__.e(57325), __webpack_require__.e(64685), __webpack_require__.e(32666), __webpack_require__.e(78348), __webpack_require__.e(51513), __webpack_require__.e(27189), __webpack_require__.e(83692), __webpack_require__.e(14050), __webpack_require__.e(63443), __webpack_require__.e(68745), __webpack_require__.e(40274), __webpack_require__.e(72078), __webpack_require__.e(8746), __webpack_require__.e(76115), __webpack_require__.e(67128), __webpack_require__.e(1359), __webpack_require__.e(69343), __webpack_require__.e(35738), __webpack_require__.e(47402), __webpack_require__.e(17459), __webpack_require__.e(87015), __webpack_require__.e(74913), __webpack_require__.e(44876), __webpack_require__.e(59559), __webpack_require__.e(5603), __webpack_require__.e(71184), __webpack_require__.e(59033), __webpack_require__.e(20400), __webpack_require__.e(15577), __webpack_require__.e(39314), __webpack_require__.e(80832), __webpack_require__.e(73169), __webpack_require__.e(6826), __webpack_require__.e(38711), __webpack_require__.e(28178), __webpack_require__.e(42001), __webpack_require__.e(72964), __webpack_require__.e(39979), __webpack_require__.e(20892), __webpack_require__.e(89568), __webpack_require__.e(98555), __webpack_require__.e(30040), __webpack_require__.e(27223), __webpack_require__.e(30974), __webpack_require__.e(99466), __webpack_require__.e(61058), __webpack_require__.e(17786), __webpack_require__.e(47173), __webpack_require__.e(14945), __webpack_require__.e(37437), __webpack_require__.e(35437), __webpack_require__.e(73259), __webpack_require__.e(54668), __webpack_require__.e(77586), __webpack_require__.e(73579), __webpack_require__.e(10524), __webpack_require__.e(10790), __webpack_require__.e(79407), __webpack_require__.e(10943), __webpack_require__.e(36484), __webpack_require__.e(36539), __webpack_require__.e(56917), __webpack_require__.e(91693), __webpack_require__.e(21034), __webpack_require__.e(72975), __webpack_require__.e(40942), __webpack_require__.e(38535), __webpack_require__.e(92150), __webpack_require__.e(70342), __webpack_require__.e(23439), __webpack_require__.e(5916), __webpack_require__.e(63466), __webpack_require__.e(87924), __webpack_require__.e(14438), __webpack_require__.e(58431), __webpack_require__.e(56336), __webpack_require__.e(51123), __webpack_require__.e(75441), __webpack_require__.e(92589), __webpack_require__.e(39687), __webpack_require__.e(83147), __webpack_require__.e(29135), __webpack_require__.e(25773), __webpack_require__.e(30617), __webpack_require__.e(14554), __webpack_require__.e(98479), __webpack_require__.e(95043), __webpack_require__.e(36811), __webpack_require__.e(43216), __webpack_require__.e(21501), __webpack_require__.e(76630), __webpack_require__.e(76120), __webpack_require__.e(66499), __webpack_require__.e(52265), __webpack_require__.e(55375), __webpack_require__.e(9873), __webpack_require__.e(22209), __webpack_require__.e(90219), __webpack_require__.e(50307), __webpack_require__.e(40153), __webpack_require__.e(9395), __webpack_require__.e(81365), __webpack_require__.e(62455), __webpack_require__.e(7469), __webpack_require__.e(16357), __webpack_require__.e(30543), __webpack_require__.e(94905), __webpack_require__.e(57970), __webpack_require__.e(81147), __webpack_require__.e(50726), __webpack_require__.e(69603), __webpack_require__.e(41144), __webpack_require__.e(31282), __webpack_require__.e(48292), __webpack_require__.e(80300), __webpack_require__.e(55842), __webpack_require__.e(30176), __webpack_require__.e(14789), __webpack_require__.e(67140), __webpack_require__.e(46164), __webpack_require__.e(21583), __webpack_require__.e(70919)]).then(__webpack_require__.bind(__webpack_require__, 170919)).then((mod)=>mod.PbPage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(170919)
            ]
    }
});
const BuildPC = (param)=>{
    let { pbContent , pbMetaData , pbSSRData ,  } = param;
    var ref;
    const { epicOmni1524 , baseDomain , canonicalDomain  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { loading , estimatedAmount , mappedPrintBuildPCData  } = (0,BuildPCContextV2/* useBuildPCV2 */.s)();
    const breadCrumbs = [
        {
            link: "/",
            name: (0,i18n.t)("Trang chủ")
        },
        {
            disabled: true,
            link: "#",
            name: "Build PC"
        }, 
    ];
    return epicOmni1524 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {
                isLoading: loading || false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadSection/* HeadSection */.I, _objectSpreadProps(_objectSpread({}, pbMetaData ? {
                            title: pbMetaData.metaTitle,
                            description: pbMetaData.metaDescription,
                            keywords: (ref = pbMetaData.metaKeywords) === null || ref === void 0 ? void 0 : ref.toString(),
                            schemaPage: pbMetaData.jsonLd
                        } : {}), {
                            canonical: "".concat(canonicalDomain || baseDomain, "/buildpc")
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_es/* Container */.W, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_es/* Breadcrumbs */.O, {
                                breadcrumbs: breadCrumbs
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PbBuildPC, {
                            pbContent: pbContent,
                            pbSSRData: pbSSRData,
                            pbMetaData: pbMetaData,
                            page: "buildpc"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintBuildPc_es/* PrintBuildPc */.r, {
                total: estimatedAmount,
                buildpc: mappedPrintBuildPCData,
                logoProps: {
                    height: "60px"
                }
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPc/* BuildPc */.k, {});
};
const StyledContainer = (0,emotion_styled_browser_esm["default"])(Container_es/* Container */.W)(_templateObject());

// EXTERNAL MODULE: ./contexts/BuildPcContext.tsx
var BuildPcContext = __webpack_require__(677111);
;// CONCATENATED MODULE: ./tenants/phongvu/desktop/buildpc.tsx
function buildpc_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function buildpc_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            buildpc_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const BuildPcPage = (props)=>{
    const { epicOmni1524  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const BuildPCProvider = !!epicOmni1524 ? BuildPCContextV2/* BuildPCV2Provider */.k : BuildPcContext/* BuildPcProvider */.sf;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPCProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPC, buildpc_objectSpread({}, props))
    });
};
const getServerSideProps = (/* unused pure expression or super */ null && (getServerSidePropsBuildPC));
/* harmony default export */ var buildpc = (BuildPcPage);

;// CONCATENATED MODULE: ./pages/phongvu/desktop/buildpc.tsx
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ var desktop_buildpc = (buildpc);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [73464,23686,82175,3243,12448,33687,51357,52400,23728,39486,33054,67246,28284,62174,97270,57645,98348,91961,300,92888,14560,40179], function() { return __webpack_exec__(325523); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);